import { HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError, filter, take, switchMap } from 'rxjs/operators';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';

// Variáveis globais para gerenciar estado do interceptor
let isRefreshing = false;
const refreshTokenSubject = new BehaviorSubject<any>(null);

export const authCertificateInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  
  const authService = inject(AuthService);

  // Adiciona APENAS o certificado se disponível
  // O JWT já é tratado pelo JwtInterceptor
  let modifiedRequest = request;
  const certificate = authService.getStoredCertificate();
  if (certificate) {
    modifiedRequest = addCertificate(modifiedRequest, certificate);
  }

  return next(modifiedRequest).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 && !request.url.includes('auth/refresh')) {
        return handle401Error(modifiedRequest, next, authService);
      }
      return throwError(() => error);
    })
  );
};



function addCertificate(request: HttpRequest<unknown>, certificate: any): HttpRequest<unknown> {
  return request.clone({
    setHeaders: {
      'X-Certificate': JSON.stringify(certificate)
    }
  });
}

function handle401Error(
  request: HttpRequest<unknown>, 
  next: HttpHandlerFn, 
  authService: AuthService
): Observable<HttpEvent<unknown>> {
  if (!isRefreshing) {
    isRefreshing = true;
    refreshTokenSubject.next(null);

    return authService.refreshToken().pipe(
      switchMap((token: any) => {
        isRefreshing = false;
        refreshTokenSubject.next(token);
        // O JwtInterceptor vai adicionar o token automaticamente
        return next(request);
      }),
      catchError((err) => {
        isRefreshing = false;
        authService.logout();
        return throwError(() => err);
      })
    );
  } else {
    return refreshTokenSubject.pipe(
      filter(token => token != null),
      take(1),
      switchMap(token => {
        // O JwtInterceptor vai adicionar o token automaticamente
        return next(request);
      })
    );
  }
}
